import { useQuery } from '@tanstack/react-query';

import { queryKeys } from '~/api/queryKeys';

import { getInviteStatus } from '../services/auth.service';

/**
 * Fetches the invite/verification link status so the set-password page can
 * gate rendering. Disabled until both identifiers are present; never retried
 * (an invalid link is a definitive answer, not a transient failure).
 */
export function useInviteStatus(userId: string | undefined, token: string | undefined) {
  return useQuery({
    queryKey: queryKeys.auth.inviteStatus(userId ?? '', token ?? ''),
    queryFn: () => getInviteStatus(userId ?? '', token ?? ''),
    enabled: Boolean(userId && token),
    retry: false,
    staleTime: 0,
  });
}
